import { BaseSanitizer } from './BaseSanitizer';
import * as chrono from 'chrono-node';
export class DateSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'DATE', 'dates', enabled);
    }
    detectMatches(text) {
        const matches = [];
        const parsedResults = chrono.parse(text);
        for (const result of parsedResults) {
            matches.push({
                originalText: result.text,
                tag: '',
                startIndex: result.index,
                endIndex: result.index + result.text.length
            });
        }
        // chrono-node can return overlapping matches, so we need to deduplicate
        return this.removeOverlappingMatches(matches);
    }
}
